export default "__VITE_ASSET__5aad85f7__"